import React from 'react';

export const DatasetsPage = React.lazy(() => import('./DatasetsPage'));
